/**
 * Persists which conversation ids have already had their `before_call`
 * keyword pins fired. Survives remounts and reloads so revisiting a lead
 * does not re-send GAME PLAN / etc. on top of the previous reply.
 *
 * Storage key: `focused-view:before-call-fired` → `Record<conversationId, true>`.
 * The set grows unbounded for v1; sales reps churn through a small number of
 * conversations at a time and the entries are a few bytes each.
 */

const STORAGE_KEY = 'focused-view:before-call-fired';

type Shape = Record<string, true>;

function read(): Shape {
	try {
		const raw = window.localStorage.getItem(STORAGE_KEY);
		if (!raw) return {};
		const parsed = JSON.parse(raw);
		return typeof parsed === 'object' && parsed !== null ? (parsed as Shape) : {};
	} catch {
		return {};
	}
}

function write(value: Shape): void {
	try {
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
	} catch {
		// non-fatal
	}
}

export function hasFiredBeforeCallPins(conversationId: string | undefined): boolean {
	if (!conversationId) return false;
	return read()[conversationId] === true;
}

export function markBeforeCallPinsFired(conversationId: string | undefined): void {
	if (!conversationId) return;
	const cache = read();
	if (cache[conversationId]) return;
	cache[conversationId] = true;
	write(cache);
}
